<template>
  <el-container class="mg-report-container">
    <el-aside :width="asideWidthPx" class="report-menus" :class="{ 'is-resizing': isResizing }">
      <div class="collapse-title">
        <i class="iconfont" :class="iconClass" @click="handleCollapse" />
      </div>
      <div class="report-menus-items">
        <div class="report-menus-items__body">
          <div
            v-for="item in buttons"
            :key="item.menuId"
            class="menu-item"
            @click="handleToLink(item)"
            :class="{ active: activeMenuId === item.menuId }"
            :title="item.menuName"
          >
            {{ item.menuName }}
          </div>
        </div>
      </div>
      <div
        v-show="visible"
        class="resize-handle"
        title="拖动调整宽度"
        @mousedown.prevent="handleResizeStart"
      />
    </el-aside>
    <el-main class="report-content">
      <iframe
        class="third-page"
        frameborder="0"
        v-for="item in iframes"
        :key="item.menuId"
        v-show="activeMenuId === item.menuId"
        :src="item.extLink"
      />
    </el-main>
  </el-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import md5 from 'crypto-js/md5'
  import qs from 'qs'
  import { salt, channel } from '@/config'
  import AES from '@/utils/cryptojsAES'
  export default {
    data() {
      return {
        visible: true,
        asideWidth: 224,
        isResizing: false,
        activeMenuId: 0,
        iframes: [],
      }
    },
    computed: {
      ...mapGetters({
        belongId: 'user/belongId',
        belongCode: 'user/belongCode',
        employeeName: 'user/employeeName',
        employeeNo: 'user/employeeNo',
      }),
      buttons() {
        return this.$route.meta.buttons || []
      },
      iconClass() {
        return this.visible ? 'mg-icon_shangyiye' : 'mg-icon_xiayiye'
      },
      asideWidthPx() {
        return this.visible ? `${this.asideWidth}px` : '40px'
      },
      isActiveIframe() {
        return this.iframes.findIndex((item) => item.menuId === this.activeMenuId) !== -1
      },
    },
    mounted() {
      this.setActiveMenuItem()
    },
    beforeDestroy() {
      this.stopResize()
    },
    methods: {
      setActiveMenuItem() {
        const button = this.buttons.find((item) => item.menuId == this.$route.query.menuId)
        if (button) {
          this.handleToLink(button)
        }
      },
      handleToLink(item) {
        this.activeMenuId = item.menuId
        // 需要AES加密的链接处理
        const needAESUrls = ['dh.datart.mg.cn']
        // 十六位十六进制数作为密钥
        const key = 'RktYdXd47yPjvq2c'
        const AESEncryptText = AES.encrypt(key, {
          param_partner_code: this.belongCode,
          param_employee_no: this.employeeNo,
        })
        this.$nextTick(() => {
          if (!this.isActiveIframe) {
            if (item.extLink.startsWith('http')) {
              const url = new URL(item.extLink)
              const params = qs.parse(url.search, { ignoreQueryPrefix: true })
              if (needAESUrls.includes(url.host)) {
                // 链接有效性: 1个小时
                const AESXtimestamp = new Date().getTime() + 60 * 60 * 1000
                // 验签 -- sourceCode + timestamp + secre 进行md5加密
                const signature = md5('2' + AESXtimestamp + 'b9bf7aa941d043017ec667287d6c2d64').toString()
                params['user'] = this.employeeName
                params['parameter'] = AESEncryptText
                params['timestamp'] = AESXtimestamp
                params['signature'] = signature
                const urlParams = Object.keys(params).map((item) => {
                  let itemStr = `${item}=${params[item]}`
                  return itemStr
                })
                item.extLink = `${url.origin}${url.pathname}?&${urlParams.join('&')}`
                this.iframes.push(item)
                return false
              }
              params.param_partner_id = this.belongId
              params.param_partner_code = this.belongCode
              url.search = qs.stringify(params, { addQueryPrefix: true })
              const xtimestamp = new Date().getTime()
              const xsign = md5(md5(url.pathname + url.search + salt).toString() + xtimestamp).toString()
              params['X-SIGN'] = xsign
              params['X-EXT-CHANNEL'] = channel
              params['X-TIMESTAMP'] = xtimestamp
              url.search = qs.stringify(params, { addQueryPrefix: true })
              item.extLink = url.toString()
              this.iframes.push(item)
            }
          }
        })
      },
      handleCollapse() {
        this.visible = !this.visible
      },
      handleResizeStart(event) {
        if (!this.visible) return

        this.isResizing = true
        const startX = event.clientX
        const startWidth = this.asideWidth

        const onMouseMove = (moveEvent) => {
          const nextWidth = startWidth + moveEvent.clientX - startX
          this.asideWidth = Math.min(Math.max(nextWidth, 160), 480)
        }

        const onMouseUp = () => {
          this.stopResize()
        }

        this._resizeMouseMove = onMouseMove
        this._resizeMouseUp = onMouseUp
        document.body.style.cursor = 'col-resize'
        document.body.style.userSelect = 'none'
        document.addEventListener('mousemove', onMouseMove)
        document.addEventListener('mouseup', onMouseUp)
      },
      stopResize() {
        this.isResizing = false
        document.body.style.cursor = ''
        document.body.style.userSelect = ''

        if (this._resizeMouseMove) {
          document.removeEventListener('mousemove', this._resizeMouseMove)
          this._resizeMouseMove = null
        }

        if (this._resizeMouseUp) {
          document.removeEventListener('mouseup', this._resizeMouseUp)
          this._resizeMouseUp = null
        }
      },
    },
  }
</script>
<style lang="scss">
  .mg-report-container {
    min-height: calc(100vh - 100px) !important;
    background: #ebedf0 !important;
    padding: 0 !important;

    .report-menus {
      position: relative;
      background: #fff;
      margin-right: 8px;
      &.is-resizing {
        user-select: none;
      }
      .resize-handle {
        position: absolute;
        top: 0;
        right: -4px;
        z-index: 10;
        width: 8px;
        height: 100%;
        cursor: col-resize;
        background: rgba(230, 0, 18, 0.08);
        border-left: 2px solid rgba(230, 0, 18, 0.35);
        box-sizing: border-box;
        &:hover {
          background: rgba(230, 0, 18, 0.16);
          border-left-color: rgba(230, 0, 18, 0.6);
        }
      }
      .collapse-title {
        text-align: right;
        border-bottom: 1px solid #ddd;
        padding: 3px 8px;
        i {
          font-size: 18px;
          border: 1px solid #ddd;
          border-radius: 4px;
          &:hover {
            color: #e60012;
            border-color: #e60012;
          }
        }
        span {
          color: #252a3d;
          font-weight: 500;
        }
      }
      .report-menus-items {
        padding: 10px 0;
        height: calc(100vh - 150px);
        overflow-x: scroll;
        overflow-y: auto;
        scrollbar-gutter: stable both-edges;
        scrollbar-width: thin;
        scrollbar-color: rgba(0, 0, 0, 0.35) #ececec;

        &::-webkit-scrollbar {
          width: 10px;
          height: 10px;
          -webkit-appearance: none;
        }

        &::-webkit-scrollbar-thumb {
          min-width: 40px;
          background-color: rgba(0, 0, 0, 0.35);
          border: 2px solid #ececec;
          border-radius: 5px;
        }

        &::-webkit-scrollbar-thumb:hover {
          background-color: rgba(0, 0, 0, 0.5);
        }

        &::-webkit-scrollbar-track {
          background-color: #ececec;
        }

        &::-webkit-scrollbar-corner {
          background-color: #ececec;
        }

        &__body {
          display: inline-block;
          min-width: calc(100% + 1px);
          width: max-content;
          vertical-align: top;
        }

        .menu-item {
          color: #292e40;
          white-space: nowrap;
          line-height: 30px;
          padding: 0 12px;
          box-sizing: border-box;
          &:hover {
            background: rgba(37, 42, 61, 0.05);
            cursor: pointer;
          }
          &.active {
            color: '#e60012';
            background: rgba(37, 42, 61, 0.05);
          }
        }
      }
    }

    .report-content {
      padding: 8px;
      background: #fff;
      .third-page {
        width: 100%;
        height: calc(100% - 8px);
      }
    }
  }
</style>
